import { Chip } from "@mui/material";
import { useState } from "react";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import RenderWithTooltip from "../../../../components/RenderWithTooltip";
import useCurrentUser from "../../../../hooks/local-storage/use-current-user";
import {
  PatientSEVERITY_BG_COLOR,
  PatientSEVERITY_COLOR,
  PatientSEVERITY_RECORD,
} from "../../../../pages/app/provider/patient/patient-list/patient-chart-new/allergy/allergy-constant";
import { usePatientPortalAllergyListHealthRecord } from "../../../../queries/allergies/use-patient-allergies-list-health-record";
import { formatDate } from "../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  getXtenantId,
} from "../../../../utils/utils";

const PatientPortalAllergies = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [currentUser] = useCurrentUser();

  const { data: allergyList } = usePatientPortalAllergyListHealthRecord({
    patientUuid: currentUser?.uuid ?? "",
    pagination,
    xTENANTID: getXtenantId() ?? undefined,
  });

  const columns = [
    {
      field: "allergy",
      headerName: "Allergies",
      flex: 1,
      renderCell: ({ value }: any) => <RenderWithTooltip value={value} />,
    },
    {
      field: "reaction",
      headerName: "Reaction",
      flex: 1,
      renderCell: ({ value }: any) => <RenderWithTooltip value={value} />,
    },
    {
      field: "severity",
      headerName: "Severity",
      flex: 1,
      renderCell: ({ value }: any) => {
        const color = PatientSEVERITY_COLOR[value];
        const label = PatientSEVERITY_RECORD[value];
        const bgColor = PatientSEVERITY_BG_COLOR[value];
        if (!label) return "-";
        return (
          <Chip
            size="small"
            label={label}
            sx={{
              color: color,
              backgroundColor: bgColor || `${color}1A`,
              fontWeight: 500,
              height: "26px",
            }}
          />
        );
      },
    },
    {
      field: "recorded_date",
      headerName: "Recorded Date",
      flex: 1,
      renderCell: ({ row }: any) =>
        row?.recordedDate ? formatDate(row?.recordedDate) : "-",
    },
    {
      field: "recorded_by",
      headerName: "Recorded By",
      flex: 1,
      renderCell: ({ row }: any) => (row?.recordedBy ? row?.recordedBy : "-"),
    },
  ];

  return (
    <CustomDataGridV2
      getRowId={(row) => row?.uuid}
      rows={allergyList?.content ?? []}
      rowCount={allergyList?.page?.totalElements ?? 0}
      columns={columns}
      paginationModel={pagination}
      onPaginationModelChange={setPagination}
    />
  );
};

export default PatientPortalAllergies;
